module.exports = __webpack_public_path__ + "static/media/marc.0a755562.jpg";